// src/pages/ClientData/components/CollapsibleSection.js
import React, { useState } from 'react';

const CollapsibleSection = ({
  title,
  icon,
  badge,
  defaultOpen = false,
  actions,
  children,
  level = 0,
  open: controlledOpen,
  onToggle
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const handleToggle = () => {
    if (isControlled) {
      onToggle?.(!open);
    } else {
      setInternalOpen((v) => !v);
    }
  };

  return (
    <div className={`cd-section cd-section-level-${level} ${open ? 'open' : 'closed'}`}>
      <div className="cd-section-header" onClick={handleToggle}>
        <span className="cd-section-toggle" aria-hidden="true">{open ? '▾' : '▸'}</span>
        {icon && <span className="cd-section-icon">{icon}</span>}
        <span className="cd-section-title">{title}</span>
        {badge && <span className="cd-section-badge">{badge}</span>}
        {actions && (
          <div className="cd-section-actions" onClick={(e) => e.stopPropagation()}>
            {actions}
          </div>
        )}
      </div>
      {open && <div className="cd-section-body">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
